import React from 'react'

import Table from '../TableComponent'
import RoomRow from '../RoomRowComponent'
import CustomerComponent from '../CustomerComponent'

export default class StepThreeComponent extends React.Component {

    render() {
        let { selectedRoom, startDate, onPaymentComplete, config } = this.props

        return (
            <div>
                <p
                    style={{
                        fontFamily: 'Montserrat, sans-serif',
                        color: '#F06F2F',
                        fontWeight: 700
                    }}
                >
                    Du har valgt nedenstående box og startdato
                </p>
                <Table>
                    <tbody>
                        <RoomRow
                            room={{
                                ...selectedRoom,
                                date: startDate.format('DD/MM/YYYY')
                            }}
                        />
                    </tbody>
                </Table>
                <p
                    style={{
                        fontFamily: 'Montserrat, sans-serif',
                        fontWeight: 700,
                        color: '#666666',
                        lineHeight: 1.5
                    }}
                >
                    Bemærk det er en abonnementsbetaling. Fremover trækker vi
                    automatisk beløbet på dit kort hver måned, indtil du opsiger
                    aftalen. Vedr. opsigelse så kan du læse mere om dette i
                    vores handelsbetingelser.
                </p>
                <CustomerComponent
                    startDate={startDate}
                    selectedRoom={selectedRoom}
                    onPaymentComplete={onPaymentComplete}
                    config={config}
                    />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/steps/StepThreeComponent.jsx